var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v("Edit Columns")]),
        _c("div", { class: _vm.$style.subHeader }, [
          _vm._v("Add or remove columns and arrange them by priority"),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c("columns-editor", {
            attrs: {
              columns: _vm.data.columns,
              "all-columns": _vm.otherColumns,
              get: _vm.get,
              "can-remove": _vm.canRemove,
              "can-reposition": _vm.canReposition,
              "visible-columns": _vm.visibleColumns,
            },
            on: {
              pushUp: _vm.pushUp,
              removeColumn: _vm.removeColumn,
              addColumn: _vm.addColumn,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c("button", { staticClass: "rbButton mainButton" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
            _vm._v(" Save Changes "),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }